import api from '../config/api';

export const memberService = {
  createMember: async (memberData) => {
    const response = await api.post('/members', memberData);
    return response.data;
  },

  getAllMembers: async () => {
    const response = await api.get('/members');
    return response.data;
  },

  getMember: async (id) => {
    const response = await api.get(`/members/${id}`);
    return response.data;
  },

  updateMember: async (id, memberData) => {
    const response = await api.put(`/members/${id}`, memberData);
    return response.data;
  },

  updateMemberPassword: async (id, password) => {
    const response = await api.put(`/members/${id}/password`, { password });
    return response.data;
  },

  deleteMember: async (id) => {
    const response = await api.delete(`/members/${id}`);
    return response.data;
  },

  updateProfile: async (id, profileData) => {
    const response = await api.put(`/members/profile/${id}`, profileData);
    return response.data;
  },

  uploadProfilePhoto: async (id, file) => {
    const formData = new FormData();
    formData.append('photo', file);
    const response = await api.post(`/members/profile/${id}/photo`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  // Get dashboard statistics (Admin only)
  getDashboardStats: async () => {
    const response = await api.get('/members/dashboard-stats');
    return response.data;
  }
};

